import React, {useState} from "react";
import {css, useTheme} from "@emotion/react";

import {pointer, position, pr} from "@pg-design/helpers-css";
import {CloseIcon, InfoIcon} from "@pg-design/icons-module";
import {Popover} from "@pg-design/notifications";
import {Text} from "@pg-design/text-module";

import {getCreditExplanationPopoverText} from "../../utils/get_credit_explanation_popover_text";
import {MainDataType} from "./CreditOfferBoxMainData";

interface IProps {
    type: MainDataType;
}

export const InfoIconWithPopover = (props: IProps) => {
    const theme = useTheme();
    const [isActive, setIsActive] = useState(false);

    const popoverText = getCreditExplanationPopoverText(props.type);

    return (
        <Popover
            type="success"
            arrow
            isActive={isActive}
            popoverPlace="bottom"
            appendTo="parent"
            body={
                <div css={popoverWrapper}>
                    <Text variant="info_txt_1">{popoverText}</Text>
                    <CloseIcon size="1.6" css={closeIconStyle} onClick={() => setIsActive(false)} />
                </div>
            }
            arrowStyle={arrowStyle}
            toggleOnClickOutside
            toggleClickHandler
            onPopoverClose={() => setIsActive(false)}
        >
            <InfoIcon
                size="1.6"
                wrapperSize="1.6"
                wrapperColor="transparent"
                fill={theme.colors.gray[600]}
                onClick={() => setIsActive(!isActive)}
                css={pointer}
            />
        </Popover>
    );
};

const popoverWrapper = css`
    ${position("relative")};
    ${pr(2)};
`;

const closeIconStyle = css`
    ${position("absolute")};
    right: 0;
    top: 0;
`;

const arrowStyle = css`
    left: auto;
    right: 50%;
    top: -0.4rem;
    width: 22px;
    overflow: hidden;

    &:before {
        width: 28px;
    }
`;
import React, {useState} from "react";
import {css, useTheme} from "@emotion/react";

import {pointer, position, pr} from "@pg-design/helpers-css";
import {CloseIcon, InfoIcon} from "@pg-design/icons-module";
import {Popover} from "@pg-design/notifications";
import {Text} from "@pg-design/text-module";

import {getCreditExplanationPopoverText} from "../../utils/get_credit_explanation_popover_text";
import {MainDataType} from "./CreditOfferBoxMainData";

interface IProps {
    type: MainDataType;
}

export const InfoIconWithPopover = (props: IProps) => {
    const theme = useTheme();
    const [isActive, setIsActive] = useState(false);

    const popoverText = getCreditExplanationPopoverText(props.type);

    return (
        <Popover
            type="success"
            arrow
            isActive={isActive}
            popoverPlace="bottom"
            appendTo="parent"
            body={
                <div css={popoverWrapper}>
                    <Text variant="info_txt_1">{popoverText}</Text>
                    <CloseIcon size="1.6" css={closeIconStyle} onClick={() => setIsActive(false)} />
                </div>
            }
            arrowStyle={arrowStyle}
            toggleOnClickOutside
            toggleClickHandler
            onPopoverClose={() => setIsActive(false)}
        >
            <InfoIcon
                size="1.6"
                wrapperSize="1.6"
                wrapperColor="transparent"
                fill={theme.colors.gray[600]}
                onClick={() => setIsActive(!isActive)}
                css={pointer}
            />
        </Popover>
    );
};

const popoverWrapper = css`
    ${position("relative")};
    ${pr(2)};
`;

const closeIconStyle = css`
    ${position("absolute")};
    right: 0;
    top: 0;
`;

const arrowStyle = css`
    left: auto;
    right: 50%;
    top: -0.4rem;
    width: 22px;
    overflow: hidden;

    &:before {
        width: 28px;
    }
`;
